export default __webpack_public_path__ + "static/media/talksig-text.cf43e4dd.png";